import { createBuildMode } from './BuildMode.js'
import { createPlayMode } from './PlayMode.js'
import { createShareMode } from './ShareMode.js'

const MODE_COMPONENTS = {
  build: createBuildMode,
  play: createPlayMode,
  share: createShareMode,
}

export function mountModeBody(rootEl, { activeMode, onWorkspaceReady, onEdit, initialProject }) {
  rootEl.innerHTML = ''
  const factory = MODE_COMPONENTS[activeMode]
  if (!factory) return

  const options = {}
  if (activeMode === 'build') {
    options.onWorkspaceReady = onWorkspaceReady
    options.initialProject = initialProject
  }
  if (activeMode === 'play') options.onEdit = onEdit
  if (activeMode === 'share') options.project = initialProject

  rootEl.appendChild(factory(options))
}
